<div class="container m-l-337">
    <div class="row">
        <div (click)="changeStage(true)" class="col-md-2 col-sm-pull-3" [ngClass]="(live)?'bg-Info':'bg-default'">
            <h3 style="padding-bottom: 10px;">Live</h3>
        </div>
        <div (click)="changeStage(false)" class="col-md-2 col-sm-pull-3" [ngClass]="(live)?'bg-default':'bg-Info'">
            <h3 style="padding-bottom: 10px;">Staged</h3>
        </div>
        <!--<div class="col-md-8" *ngIf="live">
            <p class=" text-danger">Info</p>
        </div>-->
        <div class="col-md-8" *ngIf="!live && !Is_Projects_View">
            <div style="position: fixed; left: 67%; cursor: pointer;" *ngIf="!IsLocked">
                <button class="btn btn-primary" style="cursor:pointer" (click)="LockStagingTab()">Lock</button>
            </div>
            <div style="position: fixed; left: 67%; cursor: pointer;" *ngIf="IsLocked">
                <button class="btn btn-primary" style="cursor:no-drop" disabled><i class="fa fa-lock"></i> {{Note}}</button>
            </div>
            <ng-container *ngIf="!CanUnlocked">
                <div style="position: fixed; right: 126px " [ngStyle]="{'cursor': !IsEnabledPublihed?'no-drop':'pointer'}">
                    <button class="btn btn-info" style="float: right;" [disabled]="!IsEnabledPublihed" [ngStyle]="{'cursor': !IsEnabledPublihed?'no-drop':'pointer'}" (click)="ResetConfirmation()">Reset Stage</button>
                </div>
            </ng-container>

            <ng-container *ngIf="CanUnlocked">
                <div style="position: fixed; right: 126px;cursor:pointer ">
                    <button class="btn btn-info" style="float: right;cursor:pointer"(click)="ResetConfirmationForcedUnlock()">Reset Stage</button>
                </div>
            </ng-container>



            <div style="position: fixed; right: 44px" [ngStyle]="{'cursor': !IsEnabledPublihed?'no-drop':'pointer'}">
                <button class="btn btn-default" style="float: right;" [disabled]="!IsEnabledPublihed" [ngStyle]="{'cursor': !IsEnabledPublihed?'no-drop':'pointer'}" (click)="PublishConfirmation()">Publish</button>
            </div>
        </div>
    </div>

</div>
<div class="component-container" *ngIf=live>
    <live-tab></live-tab>

</div>
<div class="component-container" *ngIf="!live && !Is_Projects_View">
    <staged-tab [Is_Project_Selected]="Is_Project_Selected"></staged-tab>
</div>
<div class="component-container" *ngIf="!live && Is_Projects_View" style="margin-left:14px">
    <div class="component-content col-lg-6">
        <project-list class="association-list"></project-list>
    </div>
    <div class="component-content col-lg-6">
        <Snapshot-list class="association-list"></Snapshot-list>
    </div>
</div>
<model-manipulate></model-manipulate>
<model-details [live]="live"></model-details>
<equipment-manipulate [live]="live"></equipment-manipulate>
<equipment-details></equipment-details>
<attribute-edit [live]="live"></attribute-edit>
<div bsModal #createProjectModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form>
                <div class="modal-header">
                    <button type="button" class="close" aria-hidden="true" (click)="cancelAdd()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Add Project</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="input-group">
                                <input id="Project_Name" name="Project_Name" type="text" class="form-control" placeholder="Project Name" [(ngModel)]="Project_Name" />
                                <span class="input-group-btn">
                                    <button class="btn btn-info" type="button" (click)="Create_Project()"> Add</button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" (click)="cancelAdd()">Close</button>
                    <button type="submit" class="btn btn-primary" (click)="Create_Project()">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>
<div bsModal #ResetChanges="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Reset changes
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Reset:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="Reset()">Yes Reset</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #ResetChangesAndForcedUnlock="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Reset changes
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Reset:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-warning" type="button" (click)="ResetAndForcedUnlocked()">Yes Reset</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>
<div bsModal #PublishChanges="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Publish changes
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to Publish changes:
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <i *ngIf="loading" class="fa fa-circle-o-notch fa-spin fa-2x" style="color: grey;"></i>
                <button class="btn btn-warning" type="button" (click)="PublishProject()">Confirm Publish</button>
                <button class="btn btn-primary" type="button" (click)="Close()">Cancel</button>
            </div>
        </div>
    </div>
</div>